// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --ep-header-bg: initial;
  --ep-header-text: initial;
  --ep-label: initial;
  --ep-accent: initial;
  --ep-accent-text: initial;
  --ep-input-text: initial;
  --ep-page-bg: initial;
  --ep-focus-ring: initial;
  --ep-card-bg: initial;
  --ep-surface: #ffffff;
  --ep-border: rgba(0, 0, 0, 0.08);
  --ep-error: #E53935;
  --ep-text-secondary: rgba(0, 0, 0, 0.45);
}

.ep-toolbar {
  --background: var(--ep-header-bg);
  --color: var(--ep-header-text);
  min-height: 56px;
}

ion-title p {
  font-weight: 600;
  font-size: 17px;
  margin: 0;
}

.ep-content {
  --background: var(--ep-page-bg, #f5f5f5);
}

.ep-photo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
  margin-top: 0;
  position: relative;
  z-index: 10;
}

.ep-photo-frame {
  position: relative;
}

.ep-photo-hint-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid var(--ep-border);
  background: transparent;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 200ms ease, border-color 200ms ease;
  text-transform: none;
  letter-spacing: 0.3px;
}

.ep-photo-hint-btn:hover {
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.15);
}

.ep-photo-hint-btn:active {
  background: rgba(0, 0, 0, 0.08);
}

.ep-photo-hint-btn ion-icon {
  width: 16px;
  height: 16px;
  opacity: 0.5;
}

.ep-avatar {
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.ep-photo {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  display: block;
  border: 4px solid var(--ep-header-text, #ffffff);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  transition: box-shadow 250ms ease;
  cursor: pointer;
}

.ep-photo:hover {
  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.18);
}

.ep-photo-placeholder {
  background: var(--ep-page-bg, #f0f0f0);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid var(--ep-header-text, #ffffff);
  border-radius: 50%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.ep-photo-placeholder ion-icon {
  width: 64px;
  height: 64px;
  opacity: 0.35;
  color: var(--ep-text-secondary);
}

.ep-camera-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  position: absolute;
  bottom: 4px;
  right: 4px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: transform 200ms ease, box-shadow 200ms ease;
  padding: 0;
}

.ep-camera-btn:active {
  transform: scale(0.92);
}

.ep-camera-btn ion-icon {
  width: 20px;
  height: 20px;
}

.ep-file-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.ep-form {
  padding: 16px 16px 0;
  max-width: 680px;
  margin: 0 auto;
}

.ep-card {
  background: var(--ep-surface);
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  padding: 8px 0;
}

.ep-section {
  padding: 0 0;
}

.ep-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 4px;
}

.ep-field {
  --border-width: 0 0 1px 0;
  --border-color: var(--ep-border);
  --highlight-height: 2px;
  --highlight-color: var(--ep-accent);
  --inner-padding-end: 16px;
  --inner-padding-start: 16px;
  --padding-start: 0;
  --padding-end: 0;
  --background: transparent;
  --min-height: 56px;
  --inner-box-shadow: none;
  font-family: var(--font);
  position: relative;
}

.ep-field:last-of-type {
  --border-width: 0;
}

.ep-field-area {
  --min-height: 120px;
}

.ep-label {
  font-family: var(--font);
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 2px;
  transform-origin: left center;
}

.ep-label::after {
  display: none;
}

.ep-input {
  --padding-top: 4px;
  --padding-bottom: 4px;
  --padding-start: 0;
  --color: var(--ep-input-text, #1a1a1a);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.ep-textarea {
  --padding-top: 8px;
  min-height: 96px;
}

.ep-select {
  --placeholder-color: var(--ep-text-secondary);
  --placeholder-opacity: 1;
  width: 100%;
  max-width: 100%;
}

.ep-field-icon {
  width: 18px;
  height: 18px;
  margin: auto 0;
  opacity: 0.35;
  transition: opacity 200ms ease;
}

.ep-field:hover .ep-field-icon {
  opacity: 0.6;
}

.ep-required {
  font-weight: 700;
  color: var(--ep-error);
  margin-left: 2px;
}

.ep-divider {
  height: 1px;
  background: var(--ep-border);
  margin: 4px 20px;
}

.ep-save-wrapper {
  padding: 24px 0;
  display: flex;
  justify-content: center;
}

.ep-save-btn {
  --background: var(--ep-accent);
  --color: var(--ep-accent-text);
  --border-radius: 28px;
  --box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  --padding-top: 16px;
  --padding-bottom: 16px;
  width: 100%;
  max-width: 400px;
  font-family: var(--font);
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.3px;
  text-transform: none;
  margin: 0;
  height: 52px;
  transition: opacity 200ms ease, transform 200ms ease, box-shadow 200ms ease;
}

.ep-save-btn:active {
  opacity: 0.9;
  transform: scale(0.98);
  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.ep-loader {
  display: flex;
  justify-content: center;
  padding: 32px 0;
}

.ep-bottom-safe {
  height: 32px;
}

@keyframes epFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.ep-card {
  animation: epFadeIn 350ms ease both;
}

.ep-photo-section {
  animation: epFadeIn 350ms ease 80ms both;
}

@media (prefers-reduced-motion: reduce) {
  .ep-card,
  .ep-photo-section,
  .ep-photo,
  .ep-camera-btn,
  .ep-photo-hint-btn,
  .ep-save-btn,
  .ep-field-icon {
    animation: none;
    transition: none;
  }
}
@media screen and (min-width: 768px) {
  .ep-toolbar {
    min-height: 64px;
  }
  ion-title p {
    text-align: left;
  }
  .ep-content {
    --background: var(--ep-page-bg, #f0f0f0);
  }
  .ep-photo-section {
    flex-direction: row;
    align-items: center;
    gap: 24px;
    max-width: 680px;
    margin: 0 auto;
    padding: 0 20px;
  }
  .ep-photo-hint-btn {
    margin-top: 0;
  }
  .ep-form {
    padding: 20px 20px 0;
  }
  .ep-card {
    border-radius: 20px;
    padding: 12px 0;
  }
  .ep-section-header {
    padding: 24px 24px 4px;
  }
  .ep-field {
    --inner-padding-end: 24px;
    --inner-padding-start: 24px;
    --min-height: 60px;
  }
  .ep-field-area {
    --min-height: 132px;
  }
  .ep-save-btn {
    max-width: 360px;
    height: 56px;
    font-size: 16px;
  }
  .ep-divider {
    margin: 4px 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/profile-edit/profile-edit.page.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,wCAAA;AACJ;;AAEA;EACI,iCAAA;EACA,8BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,SAAA;AACJ;;AAEA;EACI,wCAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;EACA,oBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,+BAAA;EACA,iCAAA;AACJ;;AAEA;EACI,+BAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,gDAAA;EACA,0CAAA;EACA,iCAAA;EACA,eAAA;AACJ;;AAEA;EACI,0CAAA;AACJ;;AAEA;EACI,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gDAAA;EACA,kBAAA;EACA,0CAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;EACA,uDAAA;EACA,UAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,oBAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,6BAAA;EACA,mBAAA;EACA,wEAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AACJ;;AAGA;EACI,yBAAA;EACA,gCAAA;EACA,uBAAA;EACA,mCAAA;EACA,yBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,wBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sCAAA;EACA,8EAAA;EACA,eAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,6CAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,sBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,4BAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,aAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,8BAAA;EACA,8BAAA;EACA,qBAAA;EACA,4CAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,SAAA;EACA,YAAA;EACA,2EAAA;AAAJ;;AAGA;EACI,YAAA;EACA,sBAAA;EACA,2CAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI;IAAO,UAAA;IAAY,0BAAA;EAErB;EADE;IAAO,UAAA;IAAY,wBAAA;EAKrB;AACF;AAHA;EACI,mCAAA;AAKJ;;AAFA;EACI,wCAAA;AAKJ;;AAFA;EACI;;;;;;;IAOI,eAAA;IACA,gBAAA;EAKN;AACF;AAFA;EACI;IACI,gBAAA;EAIN;EADE;IACI,gBAAA;EAGN;EAAE;IACI,wCAAA;EAEN;EACE;IACI,mBAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;EACN;EAEE;IACI,aAAA;EAAN;EAGE;IACI,oBAAA;EADN;EAIE;IACI,mBAAA;IACA,eAAA;EAFN;EAKE;IACI,sBAAA;EAHN;EAME;IACI,yBAAA;IACA,2BAAA;IACA,kBAAA;EAJN;EAOE;IACI,mBAAA;EALN;EAQE;IACI,gBAAA;IACA,YAAA;IACA,eAAA;EANN;EASE;IACI,gBAAA;EAPN;AACF","sourcesContent":[":host {\n    --ep-header-bg: initial;\n    --ep-header-text: initial;\n    --ep-label: initial;\n    --ep-accent: initial;\n    --ep-accent-text: initial;\n    --ep-input-text: initial;\n    --ep-page-bg: initial;\n    --ep-focus-ring: initial;\n    --ep-card-bg: initial;\n    --ep-surface: #ffffff;\n    --ep-border: rgba(0, 0, 0, 0.08);\n    --ep-error: #E53935;\n    --ep-text-secondary: rgba(0, 0, 0, 0.45);\n}\n\n.ep-toolbar {\n    --background: var(--ep-header-bg);\n    --color: var(--ep-header-text);\n    min-height: 56px;\n}\n\nion-title p {\n    font-weight: 600;\n    font-size: 17px;\n    margin: 0;\n}\n\n.ep-content {\n    --background: var(--ep-page-bg, #f5f5f5);\n}\n\n.ep-photo-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 20px;\n    margin-top: 0;\n    position: relative;\n    z-index: 10;\n}\n\n.ep-photo-frame {\n    position: relative;\n}\n\n.ep-photo-hint-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 10px;\n    padding: 6px 14px;\n    border-radius: 20px;\n    border: 1px solid var(--ep-border);\n    background: transparent;\n    font-family: var(--font);\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 200ms ease, border-color 200ms ease;\n    text-transform: none;\n    letter-spacing: 0.3px;\n}\n\n.ep-photo-hint-btn:hover {\n    background: rgba(0, 0, 0, 0.04);\n    border-color: rgba(0, 0, 0, 0.15);\n}\n\n.ep-photo-hint-btn:active {\n    background: rgba(0, 0, 0, 0.08);\n}\n\n.ep-photo-hint-btn ion-icon {\n    width: 16px;\n    height: 16px;\n    opacity: 0.5;\n}\n\n.ep-avatar {\n    width: 130px;\n    height: 130px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.ep-photo {\n    width: 130px;\n    height: 130px;\n    border-radius: 50%;\n    object-fit: cover;\n    object-position: center;\n    display: block;\n    border: 4px solid var(--ep-header-text, #ffffff);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);\n    transition: box-shadow 250ms ease;\n    cursor: pointer;\n}\n\n.ep-photo:hover {\n    box-shadow: 0 6px 28px rgba(0, 0, 0, 0.18);\n}\n\n.ep-photo-placeholder {\n    background: var(--ep-page-bg, #f0f0f0);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 4px solid var(--ep-header-text, #ffffff);\n    border-radius: 50%;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);\n}\n\n.ep-photo-placeholder ion-icon {\n    width: 64px;\n    height: 64px;\n    opacity: 0.35;\n    color: var(--ep-text-secondary);\n}\n\n.ep-camera-btn {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: none;\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n    z-index: 5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n    transition: transform 200ms ease, box-shadow 200ms ease;\n    padding: 0;\n}\n\n.ep-camera-btn:active {\n    transform: scale(0.92);\n}\n\n.ep-camera-btn ion-icon {\n    width: 20px;\n    height: 20px;\n}\n\n.ep-file-input {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n}\n\n.ep-form {\n    padding: 16px 16px 0;\n    max-width: 680px;\n    margin: 0 auto;\n}\n\n.ep-card {\n    background: var(--ep-surface);\n    border-radius: 16px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);\n    overflow: hidden;\n    padding: 8px 0;\n}\n\n.ep-section {\n    padding: 0 0;\n}\n\n.ep-section-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 20px 20px 4px;\n}\n\n\n.ep-field {\n    --border-width: 0 0 1px 0;\n    --border-color: var(--ep-border);\n    --highlight-height: 2px;\n    --highlight-color: var(--ep-accent);\n    --inner-padding-end: 16px;\n    --inner-padding-start: 16px;\n    --padding-start: 0;\n    --padding-end: 0;\n    --background: transparent;\n    --min-height: 56px;\n    --inner-box-shadow: none;\n    font-family: var(--font);\n    position: relative;\n}\n\n.ep-field:last-of-type {\n    --border-width: 0;\n}\n\n.ep-field-area {\n    --min-height: 120px;\n}\n\n.ep-label {\n    font-family: var(--font);\n    font-weight: 400;\n    font-size: 14px;\n    margin-bottom: 2px;\n    transform-origin: left center;\n}\n\n.ep-label::after {\n    display: none;\n}\n\n.ep-input {\n    --padding-top: 4px;\n    --padding-bottom: 4px;\n    --padding-start: 0;\n    --color: var(--ep-input-text, #1a1a1a);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.ep-textarea {\n    --padding-top: 8px;\n    min-height: 96px;\n}\n\n.ep-select {\n    --placeholder-color: var(--ep-text-secondary);\n    --placeholder-opacity: 1;\n    width: 100%;\n    max-width: 100%;\n}\n\n.ep-field-icon {\n    width: 18px;\n    height: 18px;\n    margin: auto 0;\n    opacity: 0.35;\n    transition: opacity 200ms ease;\n}\n\n.ep-field:hover .ep-field-icon {\n    opacity: 0.6;\n}\n\n.ep-required {\n    font-weight: 700;\n    color: var(--ep-error);\n    margin-left: 2px;\n}\n\n.ep-divider {\n    height: 1px;\n    background: var(--ep-border);\n    margin: 4px 20px;\n}\n\n.ep-save-wrapper {\n    padding: 24px 0;\n    display: flex;\n    justify-content: center;\n}\n\n.ep-save-btn {\n    --background: var(--ep-accent);\n    --color: var(--ep-accent-text);\n    --border-radius: 28px;\n    --box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);\n    --padding-top: 16px;\n    --padding-bottom: 16px;\n    width: 100%;\n    max-width: 400px;\n    font-family: var(--font);\n    font-weight: 700;\n    font-size: 15px;\n    letter-spacing: 0.3px;\n    text-transform: none;\n    margin: 0;\n    height: 52px;\n    transition: opacity 200ms ease, transform 200ms ease, box-shadow 200ms ease;\n}\n\n.ep-save-btn:active {\n    opacity: 0.9;\n    transform: scale(0.98);\n    --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.ep-loader {\n    display: flex;\n    justify-content: center;\n    padding: 32px 0;\n}\n\n.ep-bottom-safe {\n    height: 32px;\n}\n\n@keyframes epFadeIn {\n    from { opacity: 0; transform: translateY(8px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n.ep-card {\n    animation: epFadeIn 350ms ease both;\n}\n\n.ep-photo-section {\n    animation: epFadeIn 350ms ease 80ms both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .ep-card,\n    .ep-photo-section,\n    .ep-photo,\n    .ep-camera-btn,\n    .ep-photo-hint-btn,\n    .ep-save-btn,\n    .ep-field-icon {\n        animation: none;\n        transition: none;\n    }\n}\n\n@media screen and (min-width: 768px) {\n    .ep-toolbar {\n        min-height: 64px;\n    }\n\n    ion-title p {\n        text-align: left;\n    }\n\n    .ep-content {\n        --background: var(--ep-page-bg, #f0f0f0);\n    }\n\n    .ep-photo-section {\n        flex-direction: row;\n        align-items: center;\n        gap: 24px;\n        max-width: 680px;\n        margin: 0 auto;\n        padding: 0 20px;\n    }\n\n    .ep-photo-hint-btn {\n        margin-top: 0;\n    }\n\n    .ep-form {\n        padding: 20px 20px 0;\n    }\n\n    .ep-card {\n        border-radius: 20px;\n        padding: 12px 0;\n    }\n\n    .ep-section-header {\n        padding: 24px 24px 4px;\n    }\n\n    .ep-field {\n        --inner-padding-end: 24px;\n        --inner-padding-start: 24px;\n        --min-height: 60px;\n    }\n\n    .ep-field-area {\n        --min-height: 132px;\n    }\n\n    .ep-save-btn {\n        max-width: 360px;\n        height: 56px;\n        font-size: 16px;\n    }\n\n    .ep-divider {\n        margin: 4px 24px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
